module.exports = __webpack_public_path__ + "img/jacqueline-martin@1x.9de36768.jpg";